import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import SuperAdminView from './SuperAdminView';
import TenantAdminView from './TenantAdminView';
import RulesPermissions from './RulesPermissions';
import RulesAuditLog from './RulesAuditLog';
import { usePermissions } from '../../context/PermissionsContext';
import './RulesPermissions.css';

const COMPANY_ADMIN_ROLES = ['TENANT_ADMIN', 'COMPANY_OWNER', 'COMPANY_ADMIN', 'COMPANY_MANAGER', 'COMPANY_USER', 'RECRUITER'];

export default function AdminPanel() {
  const { role, tenantRole, tenantId, unrestricted, isLoading } = useAuth();
  const perms = usePermissions();
  const [tab, setTab] = useState('users');

  if (isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh' }}>
        <div className="spinner-border text-secondary" role="status" />
      </div>
    );
  }

  const canManageCompanyUsers =
    COMPANY_ADMIN_ROLES.includes(role) || COMPANY_ADMIN_ROLES.includes(tenantRole);

  if (canManageCompanyUsers && (tenantId || tenantRole)) {
    const showRules = perms.can('rules.manage') && (perms.hasRole('ADMIN') || perms.hasRole('MANAGER'));
    const showAudit = perms.can('audit.view');
    const tabs = [
      { id: 'users', label: 'User Management' },
      ...(showRules ? [{ id: 'rules', label: 'Rules & Permissions' }] : []),
      ...(showAudit ? [{ id: 'audit', label: 'Audit log' }] : []),
    ];
    const active = tabs.some((t) => t.id === tab) ? tab : 'users';
    return (
      <>
        {tabs.length > 1 && (
          <div className="admin-tabs" role="tablist">
            {tabs.map((t) => (
              <button key={t.id} type="button" role="tab" aria-selected={active === t.id}
                className={active === t.id ? 'on' : ''} onClick={() => setTab(t.id)}>
                {t.label}
              </button>
            ))}
          </div>
        )}
        {active === 'users' && <TenantAdminView onOpenRules={showRules ? () => setTab('rules') : undefined} />}
        {active === 'rules' && <RulesPermissions />}
        {active === 'audit' && <RulesAuditLog />}
      </>
    );
  }

  // Only a session with no tenant at all is platform-wide. The legacy SUPER_ADMIN
  // user flag must not reveal this view to someone who belongs to a tenant.
  if (unrestricted) {
    return <SuperAdminView />;
  }

  return <Navigate to="/analytics" replace />;
}
